import React, {useEffect, useRef} from "react";
import {Animated, View} from "react-native";

export const AnimatedCheckIcon = (props: { type:"check"|"radio", color: string, check: boolean }) => {
    const animated = useRef(new Animated.Value(0)).current;

    useEffect(() => {
        if (props.check)
            startAnim()
        else
            endAnim();
    }, [props.check])
    const startAnim = () => {
        Animated.timing(animated, {
            toValue: 20,
            duration: 100,
            useNativeDriver: false
        }).start();
    }
    const endAnim = () => {
        Animated.timing(animated, {
            toValue: 0,
            duration: 100,
            useNativeDriver: false
        }).start();
    }
    const interpolationConfig = (width: number) => {
        return {
            inputRange: [0, 20],
            outputRange: [0, width]
        }
    }

    return <View style={{
        width: 24,
        height: 24,
        borderRadius: props.type == "radio" ? 12 : 4,
        borderWidth: 3,
        borderColor: props.color
    }}>
        <Animated.View style={{
            width: animated.interpolate(interpolationConfig(7)),
            height: 3.5,
            backgroundColor: props.color,
            borderRadius: 2,
            position: "absolute",
            transform: [
                {translateY: 10},
                {translateX: -9},
                {rotate: "45deg"}
            ]
        }}/>
        <Animated.View style={{
            width: animated.interpolate(interpolationConfig(12)),
            height: 3.5,
            backgroundColor: props.color,
            borderRadius: 2,
            position: "absolute",
            transform: [
                {translateY: 8},
                {translateX: -2},
                {rotate: "-45deg"}
            ]
        }}/>
    </View>
}